import React, { useState, useRef, useEffect } from 'react';
import { ResponsiveImage } from '../';
import { lazyLoadWithDimensions } from '../../util/uiHelpers';

const LazyImage = lazyLoadWithDimensions(ResponsiveImage, { loadAfterInitialRendering: 3000 });

const OptimizedImage = ({
  rootClassName,
  alt,
  image,
  variants,
  sizes,
  placeholder = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAwIiBoZWlnaHQ9IjIwMCIgdmlld0JveD0iMCAwIDMwMCAyMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIzMDAiIGhlaWdodD0iMjAwIiBmaWxsPSIjRjNGNEY2Ii8+CjxwYXRoIGQ9Ik0xMjUgNzVMMTUwIDEwMEwxNzUgNzVWMTI1SDE1MFYxMDBIMTI1Vjc1WiIgZmlsbD0iIzlDQTNBRiIvPgo8L3N2Zz4=',
}) => {
  const [isInView, setIsInView] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);
  const imgRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isInView) {
          setIsInView(true);
          observer.disconnect();
        }
      },
      {
        rootMargin: '50px 0px', // Start loading 50px before element enters viewport
        threshold: 0.1,
      }
    );

    if (imgRef.current) {
      observer.observe(imgRef.current);
    }

    return () => observer.disconnect();
  }, [isInView]);

  if (!isInView) {
    return (
      <div
        ref={imgRef}
        className={rootClassName}
        style={{
          backgroundImage: `url("${placeholder}")`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '200px',
        }}
      />
    );
  }

  return (
    <LazyImage
      rootClassName={rootClassName}
      alt={alt}
      image={image}
      variants={variants}
      sizes={sizes}
      onLoad={() => setHasLoaded(true)}
      style={{
        opacity: hasLoaded ? 1 : 0,
        transition: 'opacity 0.3s ease-in-out',
      }}
    />
  );
};

export default OptimizedImage;
